module.exports = __webpack_public_path__ + "c4cd9e7974e2bd204705337b264510ed.svg";